import {
    Component,
    ChangeDetectionStrategy,
    forwardRef,
    Injector,
    ChangeDetectorRef,
    Input,
} from '@angular/core';
import { IsavBaseControl } from '../base-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'isav-radio-input',
    templateUrl: './radio-input.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => IsavRadioInput), multi: true },
    ],
})
export class IsavRadioInput extends IsavBaseControl {
    @Input() trueLabel: string = 'Yes';
    @Input() falseLabel: string = 'No';
    value: boolean | null = null;

    constructor(
        injector: Injector,
        private _cdRef: ChangeDetectorRef
    ) {
        super(injector);
    }

    onChange(value: boolean) {
        this.value = value;
        this._onChange(value);
        this._cdRef.markForCheck();
    }

    writeValue(obj: any): void {
        if (typeof obj === 'boolean') {
            this.value = obj;
        } else {
            this.value = null;
        }
        this._cdRef.markForCheck();
    }

    onFocus() {
        this._onTouched();
    }
}
